import { uaParser as userAgent, ENCAR_PC, ENCAR_MOBILE, ENCAR_FEM_CAR } from '@encarpkg/shared';
import encarUrlBuilder from 'app/libs/encarUrlBuilder';
import { getCookie } from 'app/libs/cookie';
import { testMobileSiteByOrigin } from 'app/libs/regEx';
import mobileAppBridge from 'app/libs/MobileAppBridge';
import { isServer } from 'app/libs/environment';
import { CUSHION_PAGE_URLS } from 'app/constants/login';

export const goHome = (replace = false, isPromotion = false) => {
	if (isServer) return;

	const makeHomeUrl = () => {
		if (userAgent().isPc) return `${ENCAR_PC}/index.do?WT.hit=unknown`;
		if (isPromotion) return `${ENCAR_FEM_CAR}?tab=sell`; // 회원가입 완료 후 접근 시 인덱스 비교견적 탭으로 이동
		return `${ENCAR_MOBILE}/index.do?WT.hit=unknown`;
	};

	const homeUrl = makeHomeUrl();

	if (replace) {
		window.location.replace(homeUrl);
	} else {
		window.location.href = homeUrl;
	}
};

export const goErrorPage = () => {
	window.location.href = '/error.html';
};

export const getSiteTypeByEncarHostname = () => {
	const hostname = getCookie('_encar_hostname');
	if (!hostname) return null;
	if (hostname && testMobileSiteByOrigin(hostname)) {
		return 'mobile';
	}
	return 'pc';
};

export const goLegacyPageByEncarHostname = (pathname = '') => {
	const hostname = getCookie('_encar_hostname');
	const nextPath = hostname ? `${hostname}${pathname}` : encarUrlBuilder().pc(pathname).mobile(pathname);

	window.location.replace(nextPath);
};

export const goMyPage = (replace = false) => {
	const myPageUrl = encarUrlBuilder().pc('/my/my_index.do').mobile('/my/my_index.do');

	if (replace) {
		window.location.replace(myPageUrl);
	} else {
		window.location.href = myPageUrl;
	}
};

// 다른 도메인으로 넘길때 fullPageUrl 사용(fem)
export const windowPopupWithApp = (target, url, width = '1024', height = '1024', fullPageUrl = null) => {
	const isApp = !!userAgent().isApp;
	if (isApp) {
		const pageUrl = fullPageUrl || `${window.location.protocol}//${window.location.host}${url}`;
		mobileAppBridge().goNativeWindow(pageUrl, 'get', '');
	} else {
		window.open(url, target, `width=${width},height=${height},scrollbars=yes`);
	}
};

/**
 * 쿠션 페이지 URL을 필터링하여 허용된 URL만 반환
 *
 * @description 서비스 쿠션 페이지 목록에 포함된 패턴이 URL에 존재하는지 확인하고,
 * 매칭되는 경우 전체 URL을 반환합니다. 매칭되지 않으면 빈 문자열을 반환.
 *
 * @param {string} returnUrl - 검증할 URL 문자열
 * @returns {string} 쿠션 페이지 패턴이 포함된 경우 전체 URL, 그렇지 않으면 빈 문자열
 *
 * @example
 * // 쿠션 페이지 패턴이 포함된 경우
 * filterReturnPageUrl('https://example.com/cars/detail/123')
 * // => 'https://example.com/cars/detail/123'
 *
 * @example
 * // 쿠션 페이지 패턴이 포함되지 않은 경우
 * filterReturnPageUrl('https://example.com/other/page')
 * // => ''
 *
 * @example
 * // 빈 문자열이나 null인 경우
 * filterReturnPageUrl('')
 * // => ''
 */
export const filterReturnPageUrl = (returnUrl) => {
	if (!returnUrl) return '';

	// 쿠션 페이지 패턴이 포함되어 있으면 전체 URL 반환
	for (const pattern of CUSHION_PAGE_URLS) {
		if (returnUrl.includes(pattern)) {
			return returnUrl;
		}
	}

	return '';
};
